import styled from 'styled-components';

import { filterProps } from 'utils/filter-props';
import { Link as RouterLink } from 'utils/navigation/router';

const Link = styled(filterProps(RouterLink, 'noBorder'))`
  display: inline-block;
  color: ${props => (props.isSelected ? Styles.color.tertiary : Styles.color.black)};
  font-size: 0.9375rem;
  text-decoration: none;
  text-transform: ${Styles.textTransform.headlines};
  position: relative;
  margin: 0 auto;

  &.selected::before,
  &::before {
    content: '';
    background-color: ${props =>
      !props.noBorder && props.isSelected ? 'currentColor' : 'transparent'};
    height: 2px;
    width: 100%;
    position: absolute;
    bottom: 0;
  }

  &:hover,
  &.selected {
    color: ${Styles.color.tertiary};
  }

  &.selected::before {
    background-color: ${props => (!props.noBorder ? 'currentColor' : 'transparent')};
  }
`;

const secondaryHoverColor = '#000'; // deviates from theme to increase color contrast
export const SecondaryLink = styled(Link)`
  color: ${props => (props.isSelected ? secondaryHoverColor : Styles.color.white)};

  &:hover,
  &.active {
    color: ${secondaryHoverColor};
  }
`;

export default Link;
